import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107055Status: 'idle',
    startProcess107055Error: undefined as any,
    loadUserParamsProcess107055Status: 'idle',
    loadUserParamsProcess107055Error: undefined as any,
    flaecheIni_UnterMietFlAktiviereUnterflaechenStatus: 'idle',
    flaecheIni_UnterMietFlAktiviereUnterflaechenError: undefined as any,

    process107055List: [] as any[],
    defaultValues: undefined as any,
    flaecheIni_UnterMietFlAktiviereUnterflaechen: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107055 = createAsyncThunk('process107055Slice/startProcess107055', async ({ process107055 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107055/`,
        prepareData(process107055),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107055Status } = getState().process107055Slice
        return startProcess107055Status !== 'pending'
    }
})

export const loadUserParamsProcess107055 = createAsyncThunk('process107055Slice/loadUserParamsProcess107055', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107055/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107055Status } = getState().process107055Slice
        return loadUserParamsProcess107055Status !== 'pending'
    }
})

export const flaecheIni_UnterMietFlAktiviereUnterflaechen = createAsyncThunk('process107055Slice/flaecheIni_UnterMietFlAktiviereUnterflaechen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/FlaecheIni_UnterMietFlAktiviereUnterflaechen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { flaecheIni_UnterMietFlAktiviereUnterflaechenStatus } = getState().process107055Slice
        return flaecheIni_UnterMietFlAktiviereUnterflaechenStatus !== 'pending'
    }
})

const Process107055Slice = createSlice({
    name: 'process107055Slice',
    initialState,
    reducers: {
        resetstartProcess107055: (state) => {
            state.job = undefined
            state.startProcess107055Error = undefined
        },
        resetstartProcess107055Error: (state) => {
            state.startProcess107055Error = undefined
        },
        resetloadUserParamsProcess107055: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107055Error = undefined
        },
        resetloadUserParamsProcess107055Error: (state) => {
            state.loadUserParamsProcess107055Error = undefined
        },
        resetflaecheIni_UnterMietFlAktiviereUnterflaechen: (state) => {
            state.flaecheIni_UnterMietFlAktiviereUnterflaechen = undefined
            state.flaecheIni_UnterMietFlAktiviereUnterflaechenError = undefined
        },
        resetflaecheIni_UnterMietFlAktiviereUnterflaechenError: (state) => {
            state.flaecheIni_UnterMietFlAktiviereUnterflaechenError = undefined
        },
        removeFromProcess107055ListById: (state, action) => {
            state.process107055List = state.process107055List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107055ListByIds: (state, action) => {
            state.process107055List = state.process107055List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107055List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107055Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107055List = []
            state.startProcess107055Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107055.pending, (state) => {
            state.startProcess107055Status = 'pending'
            state.startProcess107055Error = undefined
        })
        builder.addCase(startProcess107055.fulfilled, (state, action) => {
            state.startProcess107055Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107055.rejected, (state, action) => {
            state.startProcess107055Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107055Error = action.error.message
            } else {
                state.startProcess107055Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107055.pending, (state) => {
            state.loadUserParamsProcess107055Status = 'pending'
            state.loadUserParamsProcess107055Error = undefined
        })
        builder.addCase(loadUserParamsProcess107055.fulfilled, (state, action) => {
            state.loadUserParamsProcess107055Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107055.rejected, (state, action) => {
            state.loadUserParamsProcess107055Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107055Error = action.error.message
            } else {
                state.loadUserParamsProcess107055Error = action.payload
            }
        })

        builder.addCase(flaecheIni_UnterMietFlAktiviereUnterflaechen.pending, (state) => {
            state.flaecheIni_UnterMietFlAktiviereUnterflaechenStatus = 'pending'
            state.flaecheIni_UnterMietFlAktiviereUnterflaechenError = undefined
        })
        builder.addCase(flaecheIni_UnterMietFlAktiviereUnterflaechen.fulfilled, (state, action) => {
            state.flaecheIni_UnterMietFlAktiviereUnterflaechenStatus = 'idle'

            {
                state.flaecheIni_UnterMietFlAktiviereUnterflaechen = action.payload

            }
        })
        builder.addCase(flaecheIni_UnterMietFlAktiviereUnterflaechen.rejected, (state, action) => {
            state.flaecheIni_UnterMietFlAktiviereUnterflaechenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.flaecheIni_UnterMietFlAktiviereUnterflaechenError = action.error.message
            } else {
                state.flaecheIni_UnterMietFlAktiviereUnterflaechenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107055,
    resetstartProcess107055Error,
    resetloadUserParamsProcess107055,
    resetloadUserParamsProcess107055Error,
    resetflaecheIni_UnterMietFlAktiviereUnterflaechen,
    resetflaecheIni_UnterMietFlAktiviereUnterflaechenError,
    removeFromProcess107055ListById,
    removeFromProcess107055ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107055Slice.actions
export default Process107055Slice.reducer
